/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_PollingInputs */

const cs_property_ai_polling = /** @type {(inputs: Property_Ai_PollingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čekám na AI návrh…`)
};

const en_property_ai_polling = /** @type {(inputs: Property_Ai_PollingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting for AI draft…`)
};

/**
* | output |
* | --- |
* | "Waiting for AI draft…" |
*
* @param {Property_Ai_PollingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_polling = /** @type {((inputs?: Property_Ai_PollingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_PollingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_polling(inputs)
	return cs_property_ai_polling(inputs)
});